import React from "react";
import { Modal, Button, ButtonGroup, Stack, Text } from "@chaser/components";

const DowngradeModal = ({ open, close, onClosed }) => (
  <Modal
    title="Is downgrading right for you?"
    open={open}
    toggle={close}
    onClosed={onClosed}
  >
    <Modal.Body>
      <Stack gap="medium">
        <Text>
          Choose <strong>Book a call</strong> to complete your downgrade
        </Text>
      </Stack>
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button appearance="secondary" onClick={() => close(true)}>
          Keep my plan
        </Button>
        <Button
          onClick={() =>
            window.open(
              "https://www.chaserhq.com/meetings/chaser/subscription-support",
              "_blank",
            )
          }
        >
          Book a call
        </Button>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
);

export default DowngradeModal;
